module.exports = __webpack_public_path__ + "media/images/japan/place_1-37743876586bf9247978a5eaa760d22b.png";